import React from 'react'


export const EventRecordFilterContext = React.createContext()


export const eventRecordFilterDefaultState = {
  epicentralDistance: {
    enabled: false,
    min: '',
    max: '',
  },
  horizontalPga: {
    enabled: false,
    min: '',
    max: '',
  },
  verticalPga: {
    enabled: false,
    min: '',
    max: '',
  },
  sensorType: {
    enabled: false,
    value: '',
  }
}


export const eventRecordFilterReducer = (state, action) => {
  const {name, value} = action
  switch (action.type) {
    case 'epicentralDistance':
      if (value !== state.epicentralDistance[name]) {
        return {...state, epicentralDistance: {...state.epicentralDistance, [name]: value}}
      }
      return state
    case 'horizontalPga':
      if (value !== state.horizontalPga[name]) {
        return {...state, horizontalPga: {...state.horizontalPga, [name]: value}}
      }
      return state
    case 'verticalPga':
      if (value !== state.verticalPga[name]) {
        return {...state, verticalPga: {...state.verticalPga, [name]: value}}
      }
      return state
    case 'sensorType':
        if (value !== state.sensorType[name]) {
          return {...state, sensorType: {...state.sensorType, [name]: value}}
        }
        return state
    default:
      return state
  }
}


export const getKQuakeEventRecordApiFilter = (state) => {
  const {epicentralDistance, horizontalPga, verticalPga, sensorType} = state
  const apiFilter = {}

  // Epicentral Distance
  if (epicentralDistance.enabled) {
    if (epicentralDistance.min) {
      const parsedValue = parseFloat(epicentralDistance.min)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMinEpicentralDistanceError')
      }
      apiFilter.minepidistance = parsedValue
    }
    if (epicentralDistance.max) {
      const parsedValue = parseFloat(epicentralDistance.max)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMaxEpicentralDistanceError')
      }
      apiFilter.maxepidistance = parsedValue
    }
  }

  // Horizontal PGA
  if (horizontalPga.enabled) {
    if (horizontalPga.min) {
      const parsedValue = parseFloat(horizontalPga.min)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMinHorizontalPgaError')
      }
      apiFilter.minhpga = parsedValue
    }
    if (horizontalPga.max) {
      const parsedValue = parseFloat(horizontalPga.max)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMaxHorizontalPgaError')
      }
      apiFilter.maxhpga = parsedValue
    }
  }

  // Vertical PGA
  if (verticalPga.enabled) {
    if (verticalPga.min) {
      const parsedValue = parseFloat(verticalPga.min)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMinVerticalPgaError')
      }
      apiFilter.minvpga = parsedValue
    }
    if (verticalPga.max) {
      const parsedValue = parseFloat(verticalPga.max)
      if (Number.isNaN(parsedValue)) {
        throw new Error('invalidMaxVerticalPgaError')
      }
      apiFilter.maxvpga = parsedValue
    }
  }

  if (sensorType.enabled) {
    if (!sensorType.value) {
      throw new Error('noSensorInstallationType')
    }
    apiFilter.sensortype = sensorType.value
  }

  return apiFilter
}